<template>
  <div class="w-full overflow-hidden bg-pale-mint-grey pt-12 m:pt-16">
    <b-headline
      type="h2"
      typography="h35"
      class="mb-6 container">
      {{ $t('footer-internal-links.headline') }}
    </b-headline>
    <div class="flex overflow-x-auto container pb-16 -mb-16 l:justify-between">
      <div
        v-for="group of $t('footer-internal-links.items')"
        :key="group.title"
        class="w-64 l:w-full mr-8 m:mr-12 last:mr-0 flex-shrink-0 l:flex-shrink">
        <b-headline
          type="h3"
          typography="h4"
          class="mb-6">
          {{ group.title }}
        </b-headline>

        <ul>
          <li
            v-for="item of group.items"
            :key="item.link"
            class="mb-4 last:mb-0">
            <a
              class="text-sm hover:text-blue text-dark-grey"
              :href="item.link">{{ item.title }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="container">
      <hr class="mt-8 m:mt-12 border-light-grey border-b-0 ">
    </div>
  </div>
</template>

<script>

import BHeadline from "@/component-library/b-headline";
export default {
  name: "InternalLinksSection",
  components: {
    BHeadline
  }
};
</script>
